import React from 'react'
import { Link } from 'react-router-dom'
import { LocationDescriptorObject } from 'history'
import { useLocation, useRouteMatch } from 'react-router'
import { Location } from 'history'

type Props = React.HTMLProps<HTMLAnchorElement> & {
  children: React.ReactNode
  cardId: number
  className?: string
  state?: object
}

type State = {
  cards?: any[],
  fromLocation?: Location<State>
}

const CardLink = React.forwardRef<HTMLAnchorElement, Props>(({
  children,
  cardId,
  state,
  ...props
}, ref) => {
  const location = useLocation<State | undefined>()
  
  const cardMatch = useRouteMatch<{ cardId: string }>('/card/:cardId(\\d+)')

  const to: LocationDescriptorObject<any> = {
    pathname: `/card/${cardId}`,
  }

  to.state = {
    ...location.state,
    ...(state || {}),
    fromLocation: location.state?.fromLocation || location
  }

  if (cardMatch?.params.cardId && Number(cardMatch?.params.cardId) !== cardId) {
    to.state = {
      ...to.state,
      cards: [
        ...(location.state?.cards || []),
        {
          id: Number(cardMatch?.params.cardId),
          locationKey: location.key,
        },
      ]
    }
  }

  return (
    <Link
      {...props}
      ref={ref}
      to={to}
      replace={Number(cardMatch?.params.cardId) === cardId}
      onClick={(event) => {
        event.stopPropagation()
      }}
    >
      {children}
    </Link>
  )
})

CardLink.displayName = 'CardLink'

export default CardLink